import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: {
	[index: number]: { ts: number; command: string };
} = {};
//Just saving command sent to tigger update on count screen
export const deviceCommandSlice = createSlice({
	name: "deviceCommand",
	initialState,
	reducers: {
		updateDeviceCommand: (state, action: PayloadAction<{ id: number; command: string }>) => {
			state[action.payload.id] = { ts: Date.now(), command: action.payload.command };
		},
	},
});

export const { updateDeviceCommand } = deviceCommandSlice.actions;

export default deviceCommandSlice.reducer;
